// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2XdAYjKjNUkvcSjft_qW7D {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  background-color: #FFF;\n  padding: 0 1rem 1rem 1rem;\n  overflow: auto;\n  background: white;\n}\n._2XdAYjKjNUkvcSjft_qW7D:first-of-type {\n  padding-top: 1rem;\n}\n\n._1EbXmA97gGby7FPn2K1zcn {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row;\n  font-weight: normal;\n  justify-content: space-between;\n  margin: 0 0 0.5rem;\n  font-size: 1rem;\n  font-weight: normal;\n}\n.Xeqcb9jUL0klkYveyAB49 {\n  font-size: .65em;\n}\n._1ygNOJ0-vKjT490fY6Laye:hover {\n  text-decoration: none;\n}\n\n._2Ej-dP_8UlvuezqmVKT7oj {\n  flex: 0 0 auto;\n  line-height: 1.2rem;\n  margin: 0 0 1rem;\n}\n", ""]);
// Exports
exports.locals = {
	"ContentBox": "_2XdAYjKjNUkvcSjft_qW7D",
	"Header": "_1EbXmA97gGby7FPn2K1zcn",
	"Small": "Xeqcb9jUL0klkYveyAB49",
	"Link": "_1ygNOJ0-vKjT490fY6Laye",
	"Paragraph": "_2Ej-dP_8UlvuezqmVKT7oj"
};
module.exports = exports;
